module.exports = __webpack_public_path__ + "static/media/p_n_caf.0fc98d24.png";